import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { UseResendInvitationDialogReturn } from '../use-resend-invitation-dialog';

interface ConfirmResendViewProps {
  resendInvitationDialog: UseResendInvitationDialogReturn;
}

export const ConfirmResendView = ({
  resendInvitationDialog,
}: ConfirmResendViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-7">
      <h3 className="text-primary text-xl leading-7 font-semibold">
        {t('components.shareDialog.resendInvitation.confirmation.title')}
      </h3>
      <p className="text-primary text-sm">
        {t('components.shareDialog.resendInvitation.confirmation.description', {
          name: resendInvitationDialog.invitee?.name,
        })}
      </p>
      <div className="flex justify-center gap-4">
        <Button
          disabled={resendInvitationDialog.loading}
          variant="outline"
          onClick={resendInvitationDialog.onClose}
        >
          {t('cancel')}
        </Button>
        <Button
          loading={resendInvitationDialog.loading}
          onClick={resendInvitationDialog.onConfirm}
        >
          {t('components.shareDialog.resend')}
        </Button>
      </div>
    </div>
  );
};
